export default {
  bookExperiencePanel: 'Erlebnisbuchungspanel',
  calendarIcon: 'Kalendersymbol',
  coverImageForResource: 'Titelbild für {{title}}-Erlebnisse',
  filterBy: 'Filtern nach {{filter}}',
  filterByDateRange: 'Nach Datumsbereich filtern',
  gallery: 'Galerie',
  goBack: 'Zurück zur vorherigen Seite',
  hostUserIcon: 'Symbol für Gastgeber',
  imageOf: 'Bild von {{title}}',
  interactiveMapAltText: 'Interaktive Karte mit auswählbarem {{title}}',
  mediaSlides: 'Mediendiashow',
  muteVideo: 'Video stummschalten',
  nextPhoto: 'Nächstes Foto',
  noVideoPlayback: 'Keine Videowiedergabekapazität',
  pauseVideo: 'Video pausieren',
  photoOf: 'Foto von {{name}}',
  playVideo: 'Video abspielen',
  previousPhoto: 'Vorheriges Foto',
  moreFiltersAndExperiences: 'Weitere Filter und Erlebnisse',
  reserveSelectedSlot: 'Ausgewählten Slot reservieren',
  reviewRating: 'Bewertung der Rezension {{rating}} von 5',
  overallReviewRating: 'Gesamtbewertung der Rezensionen {{rating}} von 5',
  selectCountryCodeForPhoneNumber: 'Ländervorwahl für Telefonnummer auswählen',
  selectDate: 'Datum auswählen',
  selectParticipants: 'Teilnehmer auswählen',
  selectSessionTime: 'Sitzungszeit auswählen',
  unmuteVideo: 'Stummschaltung des Videos aufheben',
  viewShoppingCart: 'Warenkorb ansehen',
  itemsInCart: '{{count}} Artikel im Warenkorb',
  zoomIn: 'Vergrößern',
  zoomOut: 'Verkleinern',
  selectData: 'Wählen Sie {{data}}',
  reserveName: 'Reservieren Sie {{name}}',
  deleteReservation: 'Reservierung von {{experienceTitle}} löschen',
  editParticipantsFor: 'Teilnehmer für {{experienceTitle}} bearbeiten',
  enterPromoCode: 'Promo-Code eingeben',
  applyPromoCode: 'Promo-Code anwenden',
  increaseAddOnAmount: 'Erhöhen Sie die ausgewählte {{addOn}}',
  decreaseAddOnAmount: 'Verringern Sie die ausgewählte {{addOn}}',
  addOnModal: '{{addOn}} popup',
  moreInformationAboutAddOn: 'Weitere Informationen zu {{addOn}}',
  decreasePriceTierTickets: 'Tickets reduzieren {{priceTier}}',
  increasePriceTierTickets: 'Tickets erhöhen {{priceTier}}',
  downloadFilename: '{{filename}} herunterladen',
  viewFullDetailsDescription: 'Vollständige Detailsbeschreibung anzeigen',
  viewFullDescription: 'Vollständige Beschreibung anzeigen',
  closeModal: 'Modal schließen',
  hyattBanner: 'Exklusives Banner für World of Hyatt-Mitglieder',
  hyattBannerDesc:
    'Werbebanner mit exklusiven Vorteilen und Angeboten für Mitglieder des World of Hyatt Treueprogramms',
  previousSlide: 'Vorheriger Slide',
  nextSlide: 'Nächster Slide',
  paginationBulletMessage: 'Zur Slide gehen',
  exitFullscreen: 'Vollbildmodus beenden',
  enterFullscreen: 'Vollbildmodus aktivieren',
  videoSlide: 'Video Slide',
  imageSlide: 'Bild Slide',
  of: 'von',
  noDescription: 'Keine Beschreibung',
  mediaGallery: 'Karussell - Mediengalerie',
  dateSelector: 'Datumsauswahl',
  nextWeek: 'Nächste Woche',
  previousWeek: 'Vorherige Woche',
  scheduleAgenda: 'Terminplan-Agenda',
  scheduleNav: 'Terminplan-Navigation',
  scheduleViewSelector: 'Auswahl der Terminplanansicht',
  selectedDateAriaLabel: '{{date}}, ausgewählt',
  tapToBookExperience: '{{title}} buchen',
  bookExperienceAriaLabel: '{{title}} buchen',
  joinWaitlistAriaLabel: 'Warteliste für {{title}} beitreten',
};
